import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import auth from './modules/auth';
import orders from './modules/orders';
import items from './modules/items';
import deliveries from './modules/deliveries';
import clients from './modules/clients';
import staffs from './modules/staffs';
import categories from './modules/categories';
import errors from './modules/errors'; 

const store = createStore({
  state: {
    loading: false,  // Common state
    errorMessage: '',  // Common state
    managementItems : [
      {
        id : 0,
        name : "Categories"
      },
      {
        id: 1,
        name: 'Items'
      },
      {
        id: 2,
        name: 'Orders'
      },
      {
        id: 3,
        name: 'Deliveries'
      },
      {
        id: 4,
        name: 'Clients'
      },
      {
        id: 5,
        name: 'Staffs'
      },]
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    },
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
    setErrorMessage({ commit }, message) {
      commit('SET_ERROR_MESSAGE', message);
    },
  },
  getters: {
    isLoading: (state) => state.loading,
  },

  modules: {
    auth,
    orders,
    items,
    deliveries,
    clients,
    staffs,
    categories,
    errors // Register the errors module
  },
  plugins : [
    createPersistedState({
      storage: window.localStorage, // You can change to sessionStorage if needed
      key: 'haha-store', 
      paths: ['auth', 'orders'], // Specify which states to persist
    }),
  ]
});

export default store;
